import { useState } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
	dismissUserHomeGreetingForPageLoad,
	isUserHomeGreetingDismissedForPageLoad,
} from './utils/userHomeGreetingDismissed';

type UserHomeGreetingNotificationProps = {
	userGreetingName: string;
	message: string;
};

const UserHomeGreetingNotification = ({
	userGreetingName,
	message,
}: UserHomeGreetingNotificationProps) => {
	const [isVisible, setIsVisible] = useState(
		() => !isUserHomeGreetingDismissedForPageLoad(),
	);

	if (!isVisible) return null;

	const handleDismiss = () => {
		dismissUserHomeGreetingForPageLoad();
		setIsVisible(false);
	};

	return (
		<div
			role="status"
			className={cn(
				'pointer-events-auto fixed bottom-4 right-4 z-40 w-[min(20rem,calc(100vw-2rem))]',
				'rounded-xl border border-zinc-200 bg-white p-4 shadow-lg',
			)}
		>
			<div className="flex items-start gap-2">
				<div className="min-w-0 flex-1">
					<p className="text-sm font-bold text-zinc-800 md:text-base">
						Olá, {userGreetingName} 👋
					</p>
					<p className="mt-1 text-xs leading-relaxed text-zinc-500 md:text-sm">
						{message}
					</p>
				</div>
				<button
					type="button"
					onClick={handleDismiss}
					className="shrink-0 rounded-md p-1 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-600 focus:outline-none"
					aria-label="Fechar notificação"
				>
					<X className="size-4" strokeWidth={2.25} />
				</button>
			</div>
		</div>
	);
};

export { UserHomeGreetingNotification };
